"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneInput = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_intl_tel_input_1 = tslib_1.__importDefault(require("react-intl-tel-input"));
require("react-intl-tel-input/dist/main.css");
const helpers_1 = require("../../helpers");
class PhoneInput extends React.PureComponent {
    render() {
        const { defaultValue, disabled, block } = this.props;
        const onChangePhone = (fullNumber, isValid) => {
            const { onChange, validateTrigger } = this.props;
            if (isValid) {
                onChange(helpers_1.Format.getPhone(fullNumber));
                return;
            }
            validateTrigger('Wrong phone format');
        };
        const locale = getCurrentCountry();
        const containerClassDisabled = disabled ? 'clp-phone-input__container_disabled' : '';
        const containerClassBlock = block ? 'clp-phone-input__container_block' : '';
        const inputClassBlock = block ? 'clp-phone-input__input_block' : '';
        return (React.createElement(react_intl_tel_input_1.default, { disabled: disabled, preferredCountries: preferredCountries, defaultCountry: locale, defaultValue: defaultValue, inputClassName: `${inputClassBase} ${inputClassBlock}`, containerClassName: `${containerClassBase} ${containerClassBlock} ${containerClassDisabled}`, onPhoneNumberChange: (isValid = false, newNumber, countryData, fullNumber = '') => {
                onChangePhone(fullNumber, isValid);
            }, onSelectFlag: (currentNumber, countryData, fullNumber = '', isValid = false) => {
                onChangePhone(fullNumber, isValid);
            }, separateDialCode: true, formatOnInit: true, format: false }));
    }
}
exports.PhoneInput = PhoneInput;
const preferredCountries = ['fr', 'us'];
const containerClassBase = 'intl-tel--extra intl-tel-input clp-phone-input__container clp-phone-input';
const inputClassBase = 'intl-tel--input form-control clp-phone-input__input';
function getCurrentCountry() {
    var _a;
    const lng = (_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.language;
    return (lng === null || lng === void 0 ? void 0 : lng.length) >= 2 ? lng.slice(0, 2) : undefined;
}
//# sourceMappingURL=PhoneInput.js.map